import React from "react"
import {
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_DEMANDE_REGUL,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_FINALISATION,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_SIGNATURE,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_DEMANDE_RECTIFICATION,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_REJET_REGUL,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION_REGUL,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_VALIDATION,
     CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_DEMANDER_RECTIFICATION,
} from "@common-constants/*"

// Regroupe les états techniques (PersonnelDeclarationMensuelleSuivi.type) en libellés lisibles + couleur.
export function getPersonnelDeclarationEtat(type?: string): { label: string; color: string; icon: string } {
     switch (type) {
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_FINALISATION:
               return { label: "Code de signature envoyé", color: "warning", icon: "fa-paper-plane" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_SIGNATURE:
               return { label: "Signé — à valider", color: "warning", icon: "fa-pen-nib" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE:
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_DEMANDE_RECTIFICATION:
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_DEMANDER_RECTIFICATION:
               return { label: "En cours de rectification", color: "info", icon: "fa-rotate" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION:
               return { label: "Validé par le responsable", color: "primary", icon: "fa-user-check" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_VALIDATION:
               return { label: "Validé pour la paie", color: "success", icon: "fa-circle-check" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_DEMANDE_REGUL:
               return { label: "Demande de régularisation", color: "warning", icon: "fa-triangle-exclamation" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION_REGUL:
               return { label: "Régularisation validée", color: "success", icon: "fa-circle-check" }
          case CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_REJET_REGUL:
               return { label: "Régularisation rejetée", color: "danger", icon: "fa-circle-xmark" }
          default:
               return { label: "En attente de réception", color: "danger", icon: "fa-hourglass-half" }
     }
}

const PersonnelDeclarationEtatBadge = ({ type }: { type?: string }) => {
     const etat = getPersonnelDeclarationEtat(type)
     return (
          <span className={`badge badge-light-${etat.color} fw-bold px-3 py-2`}>
               <i className={`fas ${etat.icon} text-${etat.color} me-2`} />
               {etat.label}
          </span>
     )
}

export default PersonnelDeclarationEtatBadge
